//#region imports
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { Loading, Valert, DateTimePicker } from "../components";
import { Row, Col, Tooltip } from "reactstrap";
import mealPlanSummaryActions from "../actions/mealPlanSummaryActions";
import moment from "moment";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faAngleLeft, faAngleRight } from "@fortawesome/pro-light-svg-icons";

import "./styles/mealPlanner.css";
import "./styles/mealPlanSummaryModern.css";
import { loginRequired } from "../services/UserService";
//#endregion
const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "" : "",
  height: "100%",
});
const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",

  // change background colour if dragging
  background: isDragging ? "" : "",

  // styles we need to apply on draggables
  ...draggableStyle,
});
class List extends React.Component {
  constructor() {
    super();
    this.state = {
      tooltipOpen: false,
      overId: null,            // <-- droppable id under the TOP of the card
    };
    this.TRUNCATE_CHARS = 30; // max characters to show during drag
  }

  _raf = null;
  _dragId = null;

  startTopDetector = (draggableId) => {
    this._dragId = draggableId;

    const tick = () => {
      const el = document.querySelector(`[data-rbd-draggable-id='${this._dragId}']`);
      if (el) {
        const r = el.getBoundingClientRect();
        // Use the top horizontal center for robustness
        const x = r.left + r.width / 2;
        const y = r.top;

        let hit = null;
        const node = document.elementFromPoint(x, y);
        if (node) {
          const drop = node.closest && node.closest('[data-rbd-droppable-id]');
          if (drop) hit = drop.getAttribute('data-rbd-droppable-id');
        }
        if (hit !== this.state.overId) this.setState({ overId: hit });
      }
      this._raf = requestAnimationFrame(tick);
    };

    if (!this._raf) this._raf = requestAnimationFrame(tick);
  };

  stopTopDetector = () => {
    if (this._raf) cancelAnimationFrame(this._raf);
    this._raf = null;
    this._dragId = null;
    this.setState({ overId: null });
  };
  
  applyShrink = (draggableId) => {
    // 1) Locate the dragged element.
    const el = document.querySelector(`[data-rbd-draggable-id='${draggableId}']`);
    if (!el) return;

    // 2) Pick the element that actually contains the name text.
    //    Try a few sensible selectors; fallback to the whole card if none found.
    const label =
      el.querySelector('[data-name]') ||
      el.querySelector('.name') ||
      el.querySelector('label') ||
      el;

    // 3) LENGTH-BASED TRUNCATION (purely visual during drag)
    //    Touch the FIRST text node inside "label", so icons/spans (e.g., allergen) remain intact.
    //    Save the original in data-* so we can restore it on drop.
    const limit = Number.isFinite(this.TRUNCATE_CHARS) ? this.TRUNCATE_CHARS : 30;

    // Walk down to the first non-empty TEXT_NODE inside "label"
    const findFirstText = (node) => {
      if (!node) return null;
      if (node.nodeType === Node.TEXT_NODE && node.nodeValue && node.nodeValue.trim() !== "") return node;
      for (let i = 0; i < node.childNodes.length; i++) {
        const t = findFirstText(node.childNodes[i]);
        if (t) return t;
      }
      return null;
    };

    const nameTextNode = findFirstText(label);

    if (nameTextNode) {
      // Keep the original around exactly once per drag
      if (!el.dataset.origNameText) {
        el.dataset.origNameText = nameTextNode.nodeValue;
      }

      const full = el.dataset.origNameText; // use the stored canonical value
      if (full.length > limit) {
        // Trim at char boundary, drop trailing whitespace, add ellipsis
        const trimmed = full.slice(0, limit).replace(/\s+$/,"");
        nameTextNode.nodeValue = `${trimmed}…`;
      } else {
        // If short enough, ensure no ellipsis or residue from prior drags
        nameTextNode.nodeValue = full;
      }
    }
  };

  clearShrink = (draggableId) => {
    const el = document.querySelector(`[data-rbd-draggable-id='${draggableId}']`);
    if (!el) return;

    // Remove the "…" overlay on release (same label detection as applyShrink).
    const label =
      el.querySelector('[data-name]') ||
      el.querySelector('.name') ||
      el.querySelector('label') ||
      el;

    // Restore the first text node from saved value, if present
    const findFirstText = (node) => {
      if (!node) return null;
      if (node.nodeType === Node.TEXT_NODE && node.nodeValue != null) return node;
      for (let i = 0; i < node.childNodes.length; i++) {
        const t = findFirstText(node.childNodes[i]);
        if (t) return t;
      }
      return null;
    };
    const nameTextNode = findFirstText(label);
    if (nameTextNode && el.dataset.origNameText != null) {
      nameTextNode.nodeValue = el.dataset.origNameText;
    }
    delete el.dataset.origNameText;
  };

  toggle = (id) => {
    // this.setState({ tooltipOpen: !this.state.tooltipOpen, TooltipID: id });
    const nextOpen = this.state.TooltipID === id ? !this.state.tooltipOpen : true;

    this.setState({ tooltipOpen: nextOpen, TooltipID: id }, () => {
      if (this.state.tooltipOpen) {
        // wait for Popper to position, then nudge bubble only
        const targetId = id; // the Tooltip's target is exactly the 'id' we pass in render
        requestAnimationFrame(() => this.nudgeAllergenTooltip(targetId));
        // optional: keep centered on resize
        window.addEventListener('resize', this._msResizeNudge);
      } else {
        this.resetAllergenTooltipNudge();
        window.removeEventListener('resize', this._msResizeNudge);
      }
    });
  };

  // bind once in the class (field)
  _msResizeNudge = () => {
    if (!this.state.tooltipOpen || !this.state.TooltipID) return;
    this.nudgeAllergenTooltip(this.state.TooltipID);
  };

  nudgeAllergenTooltip = (targetId) => {
    // Find visible tooltip for left/right placements
    const tip =
      document.querySelector('.custom-tooltip.show[x-placement^="left"]') ||
      document.querySelector('.custom-tooltip.show[data-popper-placement^="left"]') ||
      document.querySelector('.custom-tooltip.show[x-placement^="right"]') ||
      document.querySelector('.custom-tooltip.show[data-popper-placement^="right"]');

    if (!tip) return;
    const inner = tip.querySelector('.tooltip-inner');
    const target = document.getElementById(targetId);
    if (!inner || !target) return;

    const innerH  = inner.getBoundingClientRect().height;
    const targetH = target.getBoundingClientRect().height || 0;

    // Center bubble around icon, then a slight upward fine-tune
    const nudge = ((innerH - targetH) / 2 * -1) - 6;  // tweak -6 to taste
    inner.style.marginTop = `${Math.round(nudge)}px`;
  };

  resetAllergenTooltipNudge = () => {
    const tip = document.querySelector('.custom-tooltip.show');
    if (!tip) return;
    const inner = tip.querySelector('.tooltip-inner');
    if (inner) inner.style.marginTop = '';
  };



  render() {
    const { grid, extendMeal, onDrop, setDragOver } = this.props;
    
    return (
      <ul className="mealPlanSummaryGrid">
        <Valert
          display={false}
          onRef={(ref) => (this.warningPastItemValert = ref)}
          title={this.props.t("meal_plan_summary.NOT_ALLOWED_TITLE")}
          question={this.props.t("meal_plan_summary.MOVING_NOT_ALLOWED_TITLE")}
          positiveText={this.props.t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <DragDropContext
          onBeforeDragStart={({ draggableId }) => {
            this.startTopDetector(draggableId);  // <-- start top-edge tracking
            this.applyShrink(draggableId)
          }}
          onBeforeCapture={({ draggableId }) => {
            this.applyShrink(draggableId)
          }}
          onDragEnd={(data) => {
            this.stopTopDetector();  // <-- stop tracking
            this.clearShrink(data.draggableId);

            // Prefer our TOP-edge target; fall back to RBD’s destination
            const targetDroppableId = this.state.overId || (data.destination && data.destination.droppableId);
            if (!targetDroppableId) return;

            const { source } = data;
            let fromArray = data.draggableId.split("-");
            const foodId = fromArray[0];
            const fromTime = fromArray[1];
            const fromMeal = fromArray[2].toLowerCase().replace(/ +/g, "");
            const destinationsId = targetDroppableId.split("-");
            const item = grid[destinationsId[0]];
            const mealItem = item.meals[destinationsId[1]];

            const sourceIds = source.droppableId.split("-");
            const sourceData = grid[sourceIds[0]].meals[sourceIds[1]];
            sourceData.food = data.draggableId;
            const toMeal = mealItem.type;
            // incase error occure please remove  fromTime == item.date.unix() * 1000 this condition
            let flag = true;
            if (mealItem.foods && mealItem.foods.length > 0) {
              mealItem.foods.forEach((element) => {
                if (
                  element._id == foodId &&
                  fromTime == item.date.unix() * 1000 &&
                  fromMeal == toMeal
                ) {
                  flag = false;
                }
              });
            }
            if (flag) {
              onDrop(
                sourceData,
                foodId,
                fromTime,
                fromMeal,
                item.date.unix() * 1000,
                toMeal
              );
            } else {
              //somethings
              //alert("Faild");
            }
          }}
        >
          {grid &&
            grid.map((item, i) => {
              return (
                <li key={i} className="mealPlanSummaryItem ">
                  <a href={`/mealplanner/${item.date.format("YYYY-MM-DD")}`}>
                    <h5>{item.date.format("D")}{" "}
                      {this.props.t(`meal_plan_summary.${item.date.clone().locale("en").format("dddd").toUpperCase()}`)}</h5>
                  </a>
                  {item.meals &&
                    item.meals.map((mealItem, mealI) => {
                      let isDropped = false;

                      return (
                        <Droppable
                          droppableId={`${i}-${mealI}-${mealItem.type}-${item.date.unix() * 1000}`}
                        >
                          {(provided, snapshot) => {
                            const droppableId = `${i}-${mealI}-${mealItem.type}-${item.date.unix() * 1000}`;
                            const isTopOver = this.state.overId === droppableId;
                            // Prefer our top-edge target when we have one; otherwise fall back to RBD
                            const isOver = this.state.overId ? isTopOver : snapshot.isDraggingOver;;
                            return (

                            <div
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}
                              {...provided.droppableProps}
                            >
                              <h3
                                className="drop-title"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  color: (mealItem.foods && mealItem.foods.length > 0 && isOver)
                                          ? "#007eff"
                                          : (mealItem.foods && mealItem.foods.length > 0)
                                            ? "#212529"
                                            : (isOver ? "#007eff" : "#ddd"),
                                }}
                              >
                                {mealItem.title}
                                {mealItem.foods &&
                                  mealItem.foods.length > 0 && (
                                    <i
                                      style={{
                                        fontSize: 10,
                                        paddingLeft: 7,
                                        color: "#007bff",
                                        cursor: "pointer",
                                        paddingTop: 2,
                                      }}
                                      className={
                                        mealItem.unExtend
                                          ? "fas fa-chevron-down"
                                          : "fas fa-chevron-up"
                                      }
                                      onClick={() =>
                                        extendMeal(item.date, mealItem.title)
                                      }
                                    />
                                  )}
                              </h3>
                              <div className="foodsContainer">
                                {mealItem.foods &&
                                  !mealItem.unExtend &&
                                  mealItem.foods.map((foodItem, j) => {
                                    let name = foodItem.recipe_full;
                                    let mealTitle = mealItem.type;
                                    // make id unique per row occurrence by suffixing j (occurrence index)
                                    const stableId = `${foodItem._id}-${item.date.unix() * 1000}-${mealTitle}-${j}`;
                                    const mealPlannerTooltipID = `mealPlannerTooltip-${foodItem._id
                                      }-${item.date.unix() * 1000
                                      }-${mealTitle}-${j}`;

                                    return (
                                      <Draggable
                                        key={stableId}
                                        type="food"
                                        draggableId={stableId}
                                        index={j}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}

                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          >
                                            <Row>
                                              <Col xs="1">
                                                <span
                                                  style={{
                                                    color: "#666",
                                                    fontSize: "0.8rem",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  &#8226;
                                                </span>
                                              </Col>
                                              <Col xs="11">
                                                <label data-name
                                                  style={{
                                                    wordBreak: "break-word",
                                                    marginRight:
                                                      name && name.length >= 25
                                                        ? "18%"
                                                        : "",
                                                    position: "relative",
                                                  }}
                                                >
                                                  {name}
                                                  {!!foodItem._id &&
                                                    foodItem._id.slice(0, 1) ==
                                                    "6" &&
                                                    foodItem.upc
                                                    ? `(${foodItem.upc})`
                                                    : ""}
                                                  {foodItem.allergen && (
                                                    <span
                                                      id={mealPlannerTooltipID}
                                                      style={{
                                                        paddingLeft: "7px",
                                                      }}
                                                    >
                                                      <i
                                                        id={
                                                          "mealPlannerTooltip" +
                                                          `${foodItem._id}-${item.date.unix() *
                                                          1000
                                                          }-${mealTitle.title}`
                                                        }
                                                        className="fas fa-exclamation-triangle"
                                                        style={{
                                                          color: "#CC0000",
                                                          fontSize: "0.8rem",
                                                          display: "contents",
                                                        }}
                                                      ></i>
                                                      <Tooltip
                                                        key={this.state.TooltipID} 
                                                        popperClassName="custom-tooltip mp-tooltip"
                                                        placement="right"
                                                        isOpen={this.state.TooltipID === mealPlannerTooltipID
                                                          ? this.state.tooltipOpen
                                                          : false
                                                        }
                                                        container="body"
                                                        fade={false}
                                                        target={mealPlannerTooltipID}
                                                        toggle={() => this.toggle(mealPlannerTooltipID)}
                                                        modifiers={{
                                                          arrow: {enabled: false},  // Disables default arrow
                                                          offset: {offset: "0, 10"},
                                                        }}
                                                      >
                                                        {foodItem.allergen}
                                                        <span
                                                          className="custom-tooltip-arrow"
                                                        ></span>
                                                      </Tooltip>
                                                    </span>
                                                  )}
                                                </label>
                                              </Col>
                                            </Row>
                                          </div>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                  {provided.placeholder}
                              </div>
                            </div>
                          )}}
                        </Droppable>
                      );
                    })}
                  <footer>
                    <ul>
                      {item.nutResult.map((nut, index) => {
                        return (
                          <li key={index}>
                            <span className={nut.value == 0 ? "" : "darkGrey"}>
                              {nut.name}:{" "}
                            </span>
                            {nut.value}
                            {nut.unit}
                          </li>
                        );
                      })}
                    </ul>
                  </footer>
                </li>
              );
            })}
        </DragDropContext>
      </ul>
    );
  }
  componentWillUnmount() {
    this.stopTopDetector();
  }
}
class MealPlanSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    loginRequired();
    const numOfColumn = Math.round((window.innerWidth * 7) / 1440);
    this.numOfColumn = numOfColumn;
    let newTime = null;
    if (this.props.match.params.date) {
      const momentObject = moment.unix(this.props.match.params.date);
      const startOfIsoWeek = momentObject.startOf("isoWeek");
      this.timeVal = startOfIsoWeek;
    } else {
      this.timeVal = moment().startOf("isoWeek");
    }
    this.props.initialization(numOfColumn, this.timeVal);
  }

  render() {
    const {
      timeValue,
      onChangeTime,
      grid,
      extendMeal,
      onDrop,
      moveGrid,
      isLoading,
    } = this.props;

    var gridTitle = "";
    if (grid && grid.length > 0) {
      const lang = (typeof window !== "undefined" && window.localStorage && localStorage.getItem("i18nextLng")) || "en";
      const isEn = String(lang).toLowerCase().startsWith("en");

      // Month label helper:
      // - English: use Moment’s month text (short or long)
      // - Others : use i18n full month from your keys (never slice)
      const monthLabel = (m, wantShortForEn = false) => {
        if (isEn) {
          return m.clone().locale("en").format(wantShortForEn ? "MMM" : "MMMM");
        }
        const enFull = m.clone().locale("en").format("MMMM").toUpperCase();
        return this.props.t(`meal_plan_summary.${enFull}`);
      };

      const m0 = grid[0].date;
      const mN = grid[grid.length - 1].date;

      const startMonth = parseInt(m0.format("M"));
      const endMonth   = parseInt(mN.format("M"));
      const startYear  = parseInt(m0.format("Y"));
      const endYear    = parseInt(mN.format("Y"));


      if (startMonth !== endMonth) {
        if (startYear === endYear) {
          // When months differ but year same:
          gridTitle = `${monthLabel(m0, true)}/${monthLabel(mN, true)} ${m0.format("YYYY")}`;
        } else {
          // Months + years differ:
          gridTitle = `${monthLabel(m0, true)} ${m0.format("YYYY")}/${monthLabel(mN, true)} ${mN.format("YYYY")}`;
        }
      } else {
        // Single month span:
        gridTitle = `${monthLabel(m0)} ${m0.format("YYYY")}`;
      }
    }
    return (
      <div className="vPage wide flex meal-plan-summary-modern">
        <Loading isLoading={isLoading} />
        <div className="mealPlanSummaryContainer">
          <Row>
            <Col xs="12" lg="2">
              <div className="d-block dateTimeContainer">
                <DateTimePicker
                  name="time"
                  placeholder={this.props.t("meal_plan_summary.TIME_TITLE")}
                  value={timeValue}
                  onChange={(event) => {
                    moment(event).startOf("day").unix() * 1000 !==
                      this.props.selectedDate
                      ? onChangeTime(event, this.numOfColumn)
                      : "";
                  }}
                  dateFormat="DD MMM YYYY"
                  timeDisable={true}
                />
              </div>
            </Col>

            <Col xs="12" lg="8">
              <h2>{gridTitle}</h2>
            </Col>
            <Col xs="2" />
          </Row>
          {/* <i
            className="fas fa-angle-left"
            onClick={() =>
              moveGrid(
                "previous",
                moment(timeValue).add(-1, "days"),
                this.numOfColumn
              )
            }
          /> */}

          <FontAwesomeIcon
            className="fas fa-angle-left"
            icon={faAngleLeft}
            onClick={() =>
              moveGrid(
                "previous",
                moment(timeValue).add(-1, "days"),
                this.numOfColumn
              )
            }
          />

          {/* <i
            className="fas fa-angle-right"
            onClick={() =>
              moveGrid(
                "next",
                moment(timeValue).add(1, "days"),
                this.numOfColumn
              )
            }
          /> */}

          <FontAwesomeIcon
            className="fas fa-angle-right"
            icon={faAngleRight}
            onClick={() =>
              moveGrid(
                "next",
                moment(timeValue).add(1, "days"),
                this.numOfColumn
              )
            }
          />

          <List
            grid={grid}
            extendMeal={extendMeal}
            onDrop={onDrop}
            setDragOver={this.props.setDragOver}
            t={this.props.t}
          />
        </div>
      </div>
    );
  }
}

//#region exports
MealPlanSummary = translate("translations")(MealPlanSummary);

const mapStateToProps = (state) => ({
  ...state.mealPlanSummary,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...mealPlanSummaryActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(MealPlanSummary);
//#endregion



// WEBPACK FOOTER //
// ./src/pages/MealPlanSummary.js